import axios from "axios"
import { env } from "../constants"


/* GAMES LIST */
export const games = (data) => {
    const uri = `${env.gamepoint}vip-poker/game/list`
    const token = localStorage.getItem("token")
    const headers = { headers: { Authorization: `Bearer ${token}` } }
    return axios.post(uri, data, headers).then((response) => response).catch((data) => data.response)
}

/* GAMES VIEW */
export const game = (data) => {
    const uri = `${env.gamepoint}vip-poker/game/get`
    const token = localStorage.getItem("token")
    const headers = { headers: { Authorization: `Bearer ${token}` } }
    return axios.post(uri, data, headers).then((response) => response).catch((data) => data.response)
}

/* GAME REFUND */
export const credit = (data) => {
    const uri = `${env.gamepoint}vip-poker/game/credit`
    const token = localStorage.getItem("token")
    const headers = { headers: { Authorization: `Bearer ${token}` } }
    return axios.post(uri, data, headers).then((response) => response).catch((data) => data.response)
}


/* CHANGE PAUSE STATUS */
export const togglePause = (data) => {
    const uri = `${env.gamepoint}vip-poker/game/toggle-pause-status`
    const token = localStorage.getItem("token")
    const headers = { headers: { Authorization: `Bearer ${token}` } }
    return axios.post(uri, data, headers).then((response) => response).catch((data) => data.response)
}

/* END GAME */
export const endGame = (data) => {
    const uri = `${env.gamepoint}vip-poker/game/end-game`
    const token = localStorage.getItem("token")
    const headers = { headers: { Authorization: `Bearer ${token}` } }
    return axios.post(uri, data, headers).then((response) => response).catch((data) => data.response)
}